/** 税编树形表格的行数据，四个业务字段全部展示 */
export interface TaxCategoryRow {
  key: string
  code: string
  name: string
  shortName: string | null
  rateRaw: string | null
  /** 税率能唯一映射物料税率才可选；空税率与多值税率不可选，行首不显示单选按钮 */
  selectable: boolean
  matched: boolean
  children?: TaxCategoryRow[]
}

/** MPM 返回的税编树节点，字段名与 MPM 侧一致，不做重命名 */
export interface TaxCategoryNode {
  code: string
  parentCode: string | null
  name: string
  shortName: string | null
  rateRaw: string | null
  rate: number | null
  leaf: boolean
  selectable: boolean
  matched: boolean
  children: TaxCategoryNode[]
}

/**
 * MPM 税编节点转树形表格行，同时把原始节点按编码摊平，便于确定时取回整条主数据。
 *
 * 不可选的编码仍然保留在表格里，否则命中节点的层级路径会断开。
 */
export const toTableRows = (
  nodes: TaxCategoryNode[],
  flat: Record<string, TaxCategoryNode>,
): TaxCategoryRow[] =>
  (nodes || []).map((node) => {
    flat[node.code] = node
    const children = toTableRows(node.children || [], flat)
    const row: TaxCategoryRow = {
      key: node.code,
      code: node.code,
      name: node.name,
      shortName: node.shortName,
      rateRaw: node.rateRaw,
      selectable: node.selectable,
      matched: node.matched,
    }
    // 空 children 数组会让 antd Table 给叶子行也画展开箭头，必须不带这个字段
    if (children.length) {
      row.children = children
    }
    return row
  })

/** 收集全部含子行的 key，用于筛选结果的全量展开 */
export const collectParentKeys = (rows: TaxCategoryRow[]): string[] => {
  const keys: string[] = []
  const walk = (list: TaxCategoryRow[]) => {
    list.forEach((row) => {
      if (row.children && row.children.length) {
        keys.push(row.key)
        walk(row.children)
      }
    })
  }
  walk(rows)
  return keys
}
/** 税编树形表格的行数据，四个业务字段全部展示 */
export interface TaxCategoryRow {
  key: string
  code: string
  name: string
  shortName: string | null
  rateRaw: string | null
  /** 税率能唯一映射物料税率才可选；空税率与多值税率不可选，行首不显示单选按钮 */
  selectable: boolean
  matched: boolean
  children?: TaxCategoryRow[]
}

/** MPM 返回的税编树节点，字段名与 MPM 侧一致，不做重命名 */
export interface TaxCategoryNode {
  code: string
  parentCode: string | null
  name: string
  shortName: string | null
  rateRaw: string | null
  rate: number | null
  leaf: boolean
  selectable: boolean
  matched: boolean
  children: TaxCategoryNode[]
}

/**
 * MPM 税编节点转树形表格行，同时把原始节点按编码摊平，便于确定时取回整条主数据。
 *
 * 不可选的编码仍然保留在表格里，否则命中节点的层级路径会断开。
 */
export const toTableRows = (
  nodes: TaxCategoryNode[],
  flat: Record<string, TaxCategoryNode>,
): TaxCategoryRow[] =>
  (nodes || []).map((node) => {
    flat[node.code] = node
    const children = toTableRows(node.children || [], flat)
    const row: TaxCategoryRow = {
      key: node.code,
      code: node.code,
      name: node.name,
      shortName: node.shortName,
      rateRaw: node.rateRaw,
      selectable: node.selectable,
      matched: node.matched,
    }
    // 空 children 数组会让 antd Table 给叶子行也画展开箭头，必须不带这个字段
    if (children.length) {
      row.children = children
    }
    return row
  })

/** 收集全部含子行的 key，用于筛选结果的全量展开 */
export const collectParentKeys = (rows: TaxCategoryRow[]): string[] => {
  const keys: string[] = []
  const walk = (list: TaxCategoryRow[]) => {
    list.forEach((row) => {
      if (row.children && row.children.length) {
        keys.push(row.key)
        walk(row.children)
      }
    })
  }
  walk(rows)
  return keys
}
